import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.climbStepThreeExtraCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.climbStepThreeExtraCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) =>
    state.climbStepThreeExtraCollections.data.climbStepThreeExtraCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.climbStepThreeExtraCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
